import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar.jsx";
import { NotificationProvider } from "../../context/NotificationContext.jsx";
import { MobileMenuProvider } from "../../context/MobileMenuContext.jsx";

// ─────────────────────────────────────────────────────────────────────────────
//  AppLayout
//
//  Enveloppe toute l'application avec NotificationProvider (pour que Topbar
//  et Sidebar partagent le même compteur de notifs) et, depuis le 15/09/2026,
//  MobileMenuProvider (pour que le bouton ☰ de Topbar puisse ouvrir/fermer le
//  tiroir de navigation géré par Sidebar — voir MobileMenuContext.jsx).
// ─────────────────────────────────────────────────────────────────────────────
export default function AppLayout() {
  return (
    <NotificationProvider>
      <MobileMenuProvider>
        <div className="app-wrap">
          <Sidebar />
          <div className="main-content">
            <Outlet />
          </div>
        </div>
      </MobileMenuProvider>
    </NotificationProvider>
  );
}